export const Params = {
    recordtype : 1,
    incomplete: 2,
    priority: 3,
    status: 4,
    processtype: 5,
    activity : "activity",
    vocabulary : "vocabulary",
    recordstate : "recordstate",
    CollectionItemRoutePath : "collectionitem",
    CollectionItemPeopleRoutePath : "collectionitempeople",
    username: "username",
    processCode : "processCode",
    code : "code"
}

export default Params;